import { Currency } from '@/core/currency/interfaces';

const THB: Currency = {
    name: 'Thai Baht',
    demonym: 'Thai',
    majorSingle: 'Baht',
    majorPlural: 'Baht',
    codeNumeric: '764',
    symbol: '฿',
    symbolNative: '฿',
    minorSingle: 'Satang',
    minorPlural: 'Satang',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'THB',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default THB;
